import { Link } from "react-router-dom";
function Home(){


    return(<>
   <main id="main">

  <section className="hero">
    <svg viewBox="0 0 100 100" className="hero__seal" aria-hidden="true">
      <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="0.8"/>
      <circle cx="50" cy="50" r="40" fill="none" stroke="currentColor" strokeWidth="0.6"/>
      <path id="sealTopB" d="M 14,50 A 36,36 0 1,1 86,50" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"></text>
      <path id="sealBotB" d="M 86,52 A 36,36 0 1,1 14,52" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"></text>
      <g stroke="currentColor" strokeWidth="0.8" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <line x1="50" y1="30" x2="50" y2="62"/>
        <line x1="34" y1="38" x2="66" y2="38"/>
        <path d="M34,38 l-7,14 a7,7 0 0 0 14,0 z"/>
        <path d="M66,38 l-7,14 a7,7 0 0 0 14,0 z"/>
      </g>
    </svg>
    <div className="container">
      <div className="hero__inner">
        <span className="eyebrow">Establishment of the Authority: The Government of Pakistan establishes the Legal Aid and Justice Authority under the LAJA Act, 2020.</span>
        <h1>Justice within reach &mdash; free, fair, and within your right.</h1>
        <p className="lede">The Authority provides free legal aid, financial, and ancillary assistance to the poor and vulnerable segments of society especially women and juvenile. Our primary focus is ensuring access to justice in criminal cases for those who cannot afford legal representation or the costs associated with the judicial process.</p>
        <div className="hero__actions">
          <Link to="application" className="btn btn--gold">Apply for Legal Aid</Link>
          <Link to="about" className="btn btn--outline-light">Check Your Eligibility</Link>
        </div>
      </div>
    </div>
  </section>

  <div className="stats-strip">
    <div className="container">
      <div className="stats-grid">
        <div className="stat"><span className="stat__num">682</span><span className="stat__label">Applications Received for Legal Aid</span></div>
        <div className="stat"><span className="stat__num">83</span><span className="stat__label">Cases Under Court Proceedings</span></div>
        <div className="stat"><span className="stat__num">94</span><span className="stat__label">Applications is in process</span></div>
        <div className="stat"><span className="stat__num">9</span><span className="stat__label">Panel Advocates</span></div>
      </div>
    </div>
  </div>

   <section className="section">
    <div className="container">
      <div className="section__head">
        <div><span className="eyebrow">Latest updates</span><h2>News &amp; Events</h2></div>
        <Link to="news" className="section__link">View all news &rarr;</Link>
      </div>
      <div className="grid-3">
        <article className="news-card">
          <div className="news-card__media"><img src="/images/news/trainings.jpg" alt="img" width='100%' height='100%' /></div>
          <div className="news-card__body">
            <span className="date-line">30 June 2026</span>
            <h3>UNODC & LAJA Dialogue on Expanding Access to Justice and Free Legal Aid</h3>
            <p>Discussion on Technical and Capacity-Building Support for Nationwide Free Legal Aid Delivery.</p>
            <Link to="https://www.linkedin.com/feed/update/urn:li:activity:7477779626128494592" className="read-more" target="_blank" rel="noopener noreferrer">Read news &rarr;</Link>
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__media"><img src="/images/news/crc.jpg" alt="img" width='100%' height='100%' /></div>
          <div className="news-card__body">
            <span className="date-line">15 Jan 2026</span>
            <h3>Pakistan's CRC review was screened in Islamabad</h3>
            <p>Pakistan's CRC review was screened at the ILO
Auditorium, organized by LAJA with partners.
Pakistan's UN delegation was led by State.</p>
            <Link to="https://www.youtube.com/watch?v=jYMSZsB7OwI&t=23s" className="read-more"  target="_blank" rel="noopener noreferrer">Read news &rarr;</Link>
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__media"><img src="/images/news/us.jpg" alt="img" width='100%' height='100%' /></div>
          <div className="news-card__body">
            <span className="date-line">15 Dec 2025</span>
            <h3>Meeting with U.S. Chargé d'Affaires</h3>
            <p>DG LAJA Adil Anwar met with the Acting U.S.
Chargé d'Affaires for Pakistan.</p>
            <Link to="news" className="read-more">Read news &rarr;</Link>
          </div>
        </article>
      </div>
    </div>
  </section>

  

  <section className="section section--alt" id="contact">
    <div className="container">
      <div className="section__head">
        <div><span className="eyebrow">Process</span><h2>How to apply for Legal Aid</h2></div>
      </div>
      <div className="steps">
        <div className="step">
          <span className="step__num">STEP 01</span>
          <h3>Check eligibility</h3>
          <p>Review the income and category criteria, or call the helpline to confirm you qualify for free legal aid.</p>
        </div>
        <div className="step">
          <span className="step__num">STEP 02</span>
          <h3>Submit an application</h3>
          <p>Complete the application form online and submit it. After reviewing your application, LAJA will contact you within 3–5 working days. Alternatively, you may submit your application by visiting the LAJA office.</p>
        </div>
        <div className="step">
          <span className="step__num">STEP 03</span>
          <h3>Get assigned counsel</h3>
          <p>A panel advocate is assigned to your case within 7 working days and will contact you directly.</p>
        </div>
      </div>
    </div>
  </section>

  <section className="section">
    <div className="container">
      <div className="section__head">
        <div><span className="eyebrow">What we do</span><h2>Services of the Authority</h2></div>
        <Link to="about" className="section__link">Read about our mandate &rarr;</Link>
      </div>
      <div className="grid-4">
        <div className="service-card">
          <svg className="service-card__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 3v15M5 7l-3 7a3 3 0 006 0l-3-7M19 7l-3 7a3 3 0 006 0l-3-7M5 7h0M19 7h0M5 7a7 7 0 0014 0M9 21h6"/></svg>
          <h3>Free Legal Aid</h3>
          <p>Legal representation at no cost for eligible women, children and persons below the income threshold.</p>
          <a href="#contact">Check eligibility</a>
        </div>
        <div className="service-card">
          <svg className="service-card__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7l8-4z"/></svg>
          <h3>Financial Assistance</h3>
          <p>Financial support is provided by the Government of Pakistan through the Legal Aid and Justice Authority Fund.</p>
          <Link to="/application">Application forms</Link>
        </div>
        <div className="service-card">
          <svg className="service-card__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 12h4l2-3 4 6 2-3h6M5 17l3 3 3-3M16 17l3 3 3-3"/></svg>
          <h3>Alternative Dispute Resolution and Mediation</h3>
          <p>LAJA promotes mediation, negotiation, conciliation, and arbitration for faster dispute resolution.</p>
          <Link to="/contact">Find a sitting</Link>
        </div>
        <div className="service-card">
          <svg className="service-card__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2v4M5 6l2.5 2.5M19 6l-2.5 2.5M3 12h4M17 12h4M5 18l2.5-2.5M19 18l-2.5-2.5M12 14a4 4 0 100-8 4 4 0 000 8z"/></svg>
          <h3>Public Awareness & Legal Literacy</h3>
          <p>LAJA promotes awareness of legal rights and access to justice across Pakistan.</p>
          <Link to="/news">See News & Events</Link>
        </div>
      </div>
    </div>
  </section>

 
  {/* <section className="section section--alt">
    <div className="container">
      <div className="section__head">
        <div><span className="eyebrow">What's on</span><h2>Upcoming events</h2></div>
        <a href="events.html" className="section__link">View full calendar &rarr;</a>
      </div>
      <div className="event-card">
        <div className="event-card__date"><span className="day">04</span><span className="mon">Jul</span></div>
        <div className="event-card__body">
          <h3>Legal Awareness</h3>
          <div className="event-meta"><span>10:00 &ndash; 14:00</span><span>Community Hall, Block 12</span></div>
          <p style={{margin:'0', color:'var(--ink-soft)', fontSize:'.9rem'}}>Open session on tenant rights, domestic violence protections, and free aid eligibility.</p>
        </div>
        <div className="event-card__action"><a href="events.html" className="btn btn--outline-navy btn--sm">Details</a></div>
      </div>
      <div className="event-card">
        <div className="event-card__date"><span className="day">19</span><span className="mon">Jul</span></div>
        <div className="event-card__body">
          <h3>Mediation Sittings</h3>
          <div className="event-meta"><span>09:30 &ndash; 17:00</span><span>District Court Complex</span></div>
          <p style={{margin:'0', color:'var(--ink-soft)', fontSize:'.9rem'}}>Pre-listed civil and matrimonial disputes referred for amicable settlement.</p>
        </div>
        <div className="event-card__action"><a href="events.html" className="btn btn--outline-navy btn--sm">Details</a></div>
      </div>
    </div>
  </section> */}

  {/* <section className="cta-banner">
    <div className="container">
      <div>
        <h2>You may be entitled to free legal aid.</h2>
        <p>Speak to the helpline or submit a complaint &mdash; there is no cost to apply.</p>
      </div>
      <div style={{display:'flex', gap:'14px', flexWrap:'wrap'}}>
        <a href="complaint.html" className="btn btn--gold">File a Complaint</a>
        <a href="downloads.html" className="btn btn--outline-light">Download Forms</a>
      </div>
    </div>
  </section> */}

</main>

    </>);
}

export default Home;